/* This is the EMIS ----- for primary school components */
<template>
  <v-container>
    <div>
      <span v-html="title"></span>
    </div>
    <div>
      <table style="height: 72px" border="1px;" width="590" cellspacing="0px;">
        <tbody>
          <tr>
            <td
              style="
                width: 100px;
                height: 50px;
                text-align: center;
                vertical-align: middle;
              "
              rowspan="2"
            >
              សិស្ស
            </td>
            <td class="row-header" colspan="2">ថ្នាក់ទី ១</td>
            <td class="row-header" colspan="2">ថ្នាក់ទី ២</td>
            <td class="row-header" colspan="2">ថ្នាក់ទី ៣</td>
            <td class="row-header" colspan="2">ថ្នាក់ទី ៤</td>
            <td class="row-header" colspan="2">ថ្នាក់ទី ៥</td>
            <td class="row-header" colspan="2">ថ្នាក់ទី ៦</td>
            <td class="row-header" colspan="2">សរុប</td>
          </tr>
          <tr>
            <td class="row-data">សរុប</td>
            <td class="row-data">ស្រី</td>
            <td class="row-data">សរុប</td>
            <td class="row-data">ស្រី</td>
            <td class="row-data">សរុប</td>
            <td class="row-data">ស្រី</td>
            <td class="row-data">សរុប</td>
            <td class="row-data">ស្រី</td>
            <td class="row-data">សរុប</td>
            <td class="row-data">ស្រី</td>
            <td class="row-data">សរុប</td>
            <td class="row-data">ស្រី</td>
            <td class="row-data">សរុប</td>
            <td class="row-data">ស្រី</td>
          </tr>
          <!-- This is reentry data row using ree_equ data array -->
          <tr v-for="(value, row) in e2.length - 1" :key="row">
            <td
              style="
                width: 100px;
                height: 25px;
                text-align: left;
                vertical-align: middle;
              "
            >
              {{ e2[row] }}
            </td>
            <!-- First 4 columns are disable -->
            <td class="row-data-gray"></td>
            <td class="row-data-gray"></td>
            <td class="row-data-gray"></td>
            <td class="row-data-gray"></td>
            <!-- Next 8 columns are data input -->
            <td v-for="(value, col) in 8" :key="col" class="row-data">
              <numberinput v-model="ree_equ[row].dt[col]" class="number" />
            </td>
            <!-- last two columns are total column -->
            <td class="row-data">
              <strong>{{ row1[row] | blank }}</strong>
            </td>
            <td class="row-data">
              <strong>{{ row2[row] | blank }}</strong>
            </td>
          </tr>
          <!-- This is Accelerate program data row using acc_pro data array -->
          <tr>
            <td
              style="
                width: 100px;
                height: 25px;
                text-align: left;
                vertical-align: middle;
              "
            >
              {{ e2[2] }}
            </td>
            <!-- First 6 columns are data input -->
            <td v-for="(value, col) in 6" :key="col" class="row-data">
              <numberinput v-model="acc_pro[0].dt[col]" class="number" />
            </td>
            <!-- Last 6 columns are disabled -->
            <td class="row-data-gray"></td>
            <td class="row-data-gray"></td>
            <td class="row-data-gray"></td>
            <td class="row-data-gray"></td>
            <td class="row-data-gray"></td>
            <td class="row-data-gray">
              <!-- Last 2 columns are total column -->
            </td>

            <td class="row-data">
              <strong>{{ row11[0] | blank }}</strong>
            </td>
            <td class="row-data">
              <strong>{{ row22[0] | blank }}</strong>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </v-container>
</template>

<script>
import NumberInput from "@/components/common/NumberInput.vue";
import { e2 } from "@/utils/ascf/priConfig.js";
export default {
  props: ["ree_equ", "acc_pro", "title"],
  components: {
    numberinput: NumberInput,
  },
  data() {
    return {
      e2: e2,
    };
  },
  computed: {
    // Compute function for re-entry program
    row1: function () {
      let result;
      let d = this.ree_equ;

      result = d.reduce(function (r, a, ind) {
        a.dt.forEach(function (b, i) {
          if (i % 2 === 0) {
            r[ind] = (r[ind] || 0) + Number(b);
          }
        });
        return r;
      }, []);
      return result;
    },
    row2: function () {
      let result;
      let d = this.ree_equ;

      result = d.reduce(function (r, a, ind) {
        a.dt.forEach(function (b, i) {
          if (i % 2 === 1) {
            r[ind] = (r[ind] || 0) + Number(b);
          }
        });
        return r;
      }, []);
      return result;
    },
    // Compute function for Accelerate program
    row11: function () {
      let result;
      let d = this.acc_pro;

      result = d.reduce(function (r, a, ind) {
        a.dt.forEach(function (b, i) {
          if (i % 2 === 0) {
            r[ind] = (r[ind] || 0) + Number(b);
          }
        });
        return r;
      }, []);
      return result;
    },
    row22: function () {
      let result;
      let d = this.acc_pro;

      result = d.reduce(function (r, a, ind) {
        a.dt.forEach(function (b, i) {
          if (i % 2 === 1) {
            r[ind] = (r[ind] || 0) + Number(b);
          }
        });
        return r;
      }, []);
      return result;
    },
  },
  filters: {
    blank: function (value) {
      if (value == 0) return "";
      return value;
    },
  },
};
</script>

<style scoped>
.number {
  width: 35px;
  text-align: center;
}
.row-data {
  width: 35px;
  height: 25px;
  text-align: center;
  vertical-align: middle;
}
.row-data-gray {
  width: 35px;
  height: 25px;
  text-align: center;
  vertical-align: middle;
  background-color: lightgray;
}
.row-header {
  width: 70px;
  height: 25px;
  text-align: center;
  vertical-align: middle;
}
</style>